export const GET_SONGS = 'GET_SONGS';
export const GET_ARTISTS = 'GET_ARTISTS';
export const GET_ADMINS = 'GET_ADMINS';
export const TRENDING = 'TRENDING';
export const ALPH_ORDER = 'ALPH_ORDER';
export const TRENDING_ARTIST = 'TRENDING_ARTIST';
export const ARTIST_ALPH_ORDER = 'ARTIST_ALPH_ORDER';
export const RECENTLY_UPLOADED = 'RECENTLY_UPLOADED';
export const NEXT_PAGE = 'NEXT_PAGE';
export const PREV_PAGE = 'PREV_PAGE';
export const SET_LOADING = 'SET_LOADING';
export const SET_PARENT_LOADING = 'SET_PARENT_LOADING';
export const GET_WORSHIP_SONGS = 'GET_WORSHIP_SONGS';
export const GET_PRAISE_SONGS = 'GET_PRAISE_SONGS';
export const GET_RAP_SONGS = 'GET_RAP_SONGS';
export const GET_TRENDING_WORSHIP = 'GET_TRENDING_WORSHIP';
export const GET_TRENDING_PRAISE = 'GET_TRENDING_PRAISE';
export const GET_TRENDING_RAP = 'GET_TRENDING_RAP';
export const WORSHIP_ALPH_ORDER = 'WORSHIP_ALPH_ORDER';
export const PRAISE_ALPH_ORDER = 'PRAISE_ALPH_ORDER';
export const RAP_ALPH_ORDER = 'RAP_ALPH_ORDER';
export const SEARCH_QUERY = 'SEARCH_QUERY';
export const GET_LAST_MONTH = 'GET_LAST_MONTH';
export const TRENDING_LAST_MONTH = 'TRENDING_LAST_MONTH';
export const SONG_TO_PREVIEW = 'SONG_TO_PREVIEW';
export const ARTIST_TO_PREVIEW = 'ARTIST_TO_PREVIEW';
export const SIGNED_IN_ADMIN = 'SIGNED_IN_ADMIN';
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
export const SET_SUCCESS_MESSAGE = 'SET_SUCCESS_MESSAGE';
